import React from 'react';
import { useInView } from 'react-intersection-observer';

import { ErrorBoundary } from '@nxte-nl/error-boundary';

import { TinyProductCard, Props as ProductCardProps } from
  '../../components/TinyProductCard/TinyProductCard';
import { dataLayerHooks } from '../../hooks/dataLayerHooks/dataLayerHooks';
import { dataLayerV2Hooks } from '../../hooks/dataLayerHooks/dataLayerV2Hooks';
import {
  hooks as productCardDataLayerHooks,
} from '../ProductCardDataLayerContainer/ProductCardDataLayerContainer';

export type Props = ProductCardProps & {
  id?: string;
  isTopProduct?: boolean;
  itemListID?: string;
  position: number;
};

export type onClickProps = {
  id?: string;
  path: string | null;
  position: number;
  title: string;
};

export const hooks = {
  useOnClick(
    {
      path,
      title,
      position,
      id,
    } : onClickProps,
  ) {
    return dataLayerHooks.useProductClickCallback({
      id: id || path || '',
      name: title,
      position: position,
    });
  },
};

export const TinyProductCardDataLayerContainer = React.memo((props: Props) => {
  const { path, title, position, id, productType, itemListID, isTopProduct } = props;
  const onClick = hooks.useOnClick({
    path,
    title,
    position,
    id,
  });

  const trackViewItemList = dataLayerV2Hooks.useTrackViewItemListDispatch();

  const [ref, inView] = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });

  productCardDataLayerHooks.useTrackViewItemList({
    productType,
    isTopProduct,
    trackViewItemList,
    inView,
    position,
    title,
    id,
    path,
    itemListID,
  });

  return (
    <ErrorBoundary>
      <div ref={ref}>
        <TinyProductCard {...props} onClick={onClick} />
      </div>
    </ErrorBoundary>
  );
});

TinyProductCardDataLayerContainer.displayName = 'TinyProductCardDataLayerContainer';
